export default __webpack_public_path__ + "static/media/realestateapp.5bd13c66.webp";